<template>
  <div>
    <Hero />
    <AppFeatures/>
    <AppDetails/>
  </div>
</template>

<script>
import Hero from "./digital-logging/Hero.vue";
import AppFeatures from "./digital-logging/AppFeatures.vue";
import AppDetails from "./digital-logging/AppDetails.vue"

export default {
  components: {
    Hero,
    AppFeatures,
    AppDetails
},
};
</script>

<style scoped></style>
